import React, { useState } from "react";
import Dashboard from "../../templates/Dashboard";
import InvoiceDetails from "../../modules/Billing/Components/InvoiceDetails";

const Components = {
  InvoiceDetails
};

export default (props) => {
  const [loading, setLoading] = useState(false);
  const InvoiceDetailsComp = Components[props.Comp];
  
  return (
    <Dashboard load={loading}>
      <InvoiceDetailsComp />
    </Dashboard>
  );
}; 
